import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useAuth } from '../Context/AuthContext';

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    [theme.breakpoints.up('sm')]: {
        width: '450px',
    },
}));

export default function ForgetPassword() {
    const [emailError, setEmailError] = React.useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
    const [formError, setFormError] = React.useState('');
    const [successMessage, setSuccessMessage] = React.useState('');

    const { ForgetPassword } = useAuth();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setFormError('');
        setSuccessMessage('');

        if (!validateInputs()) return;

        const data = new FormData(event.currentTarget);
        const email = data.get('email');

        const result = await ForgetPassword(email);

        if (result) {
            setSuccessMessage('Reset link has been sent to your email.');
        } else {
            setFormError(result?.message || 'Something went wrong. Please try again.');
        }
    };

    const validateInputs = () => {
        const email = document.getElementById('email');
        let isValid = true;

        if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
            setEmailError(true);
            setEmailErrorMessage('Please enter a valid email address.');
            isValid = false;
        } else {
            setEmailError(false);
            setEmailErrorMessage('');
        }

        return isValid;
    };

    return (
        <Card variant="outlined">

            <Typography
                component="h1"
                variant="h4"
                sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
            >
                Forget Password
            </Typography>
            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}
            >
                <FormControl>
                    <FormLabel htmlFor="email">Email</FormLabel>
                    <TextField
                        error={emailError}
                        helperText={emailErrorMessage}
                        id="email"
                        type="email"
                        name="email"
                        placeholder="your@email.com"
                        autoComplete="email"
                        autoFocus
                        required
                        fullWidth
                        variant="outlined"
                    />
                </FormControl>

                <Typography>You will receive a link on your email</Typography>

                {formError && (
                    <Typography color="error" variant="body2">
                        {formError}
                    </Typography>
                )}

                {successMessage && (
                    <Typography color="primary" variant="body2">
                        {successMessage}
                    </Typography>
                )}

                <Button type="submit" fullWidth variant="contained">
                    Confirm
                </Button>
            </Box>
        </Card>
    );
}
